var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layer"},[_c('div',{staticClass:"tip"},[_c('van-loading',{attrs:{"size":"24px","vertical":"","text-color":"#f0ad4e","color":"#f0ad4e"}},[_vm._v("数据加载中，请稍后...")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04cadf4d","hasScoped":true,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/libs/Loading.vue
// module id = 520
// module chunks = 1